/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'cross-flow-support.back-to-all-products': 'Tilbage til alle apps',
  'cross-flow-support.close': 'Luk',
  'cross-flow-support.product-store': 'App store',
};
